module.exports = __webpack_public_path__ + "img/drop.309671a6.svg";